import { RichText, RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
export interface IWineClubActionProps {
    subTitle: string;
    title: string;
    description?: RichText;
    warning?: RichText;
    actionConfirmedLabel: string;
    actionDeniedLabel: string;
    modalClass: string;
    actionDenied?(): Promise<void>;
    action(): Promise<string | void>;
    onDestroy?(): void;
}

interface IWineClubActionState {
    isModalOpen: boolean;
    error?: string;
}

/**
 * creates an action modal for a wineclub membership action
 */
export class WineClubAction extends React.Component<IWineClubActionProps, IWineClubActionState> {
    constructor(props: IWineClubActionProps) {
        super(props);

        this._confirmAction = this._confirmAction.bind(this);
        this._denyAction = this._denyAction.bind(this);
        this._toggle = this._toggle.bind(this);

        this.state = {
            isModalOpen: true
        };
    }

    public render(): JSX.Element {
        const { modalClass } = this.props;
        return (
            <Modal
                className={modalClass}
                autoFocus={true}
                fade={true}
                isOpen={this.state.isModalOpen}
                horizontalPosition={'center'}
                verticalPosition={'center'}
                zIndex={1000}
                applicationNode={'rsg-root'}
                toggle={this._toggle}
            >
                <ModalHeader toggle={this._toggle}>
                    <h4 className='wine-club-management__modal-heading'>{this.props.subTitle}</h4>
                </ModalHeader>
                <ModalBody>
                    {this._wineMembershipAction}
                </ModalBody>
            </Modal>
        );
    }

    private get _wineMembershipAction(): JSX.Element {
        const {
            title,
            actionConfirmedLabel,
            actionDeniedLabel
        } = this.props;

        const { error } = this.state;

        return (
            <div className='wine-club-management__modal-container'>
                <div className='wine-club-management__modal-header'>
                    <h4 className='wine-club-management__modal-title'>{title}</h4>
                </div>
                <div className='wine-club-management__modal-content'>
                    {(!error) ? this._wineMemberContent : this._displayError}
                    <div className='wine-club-management__modal-buttons'>
                        {!error && <button className='wine-club-management__modal-button wine-club-management__modal-button-confirm' onClick={this._confirmAction}>{actionConfirmedLabel}</button>}
                        <button className='wine-club-management__modal-button wine-club-management__modal-button-cancel' onClick={this._denyAction}>{actionDeniedLabel}</button>
                    </div>
                </div>
            </div>
        );
    }

    private get _displayError(): JSX.Element {
        return (<div className='wine-club-management__modal-error'>{this.state.error}</div>);
    }

    private get _wineMemberContent(): JSX.Element {
        const { description, warning } = this.props;

        return (
            <div className='wine-club-management__modal-confirmation'>
                <div className='wine-club-management__modal-confirmation-text'>
                    {description && <RichTextComponent text={description} />}
                </div>
                <div className='wine-club-management__modal-confirmation-note'>
                    {warning && <RichTextComponent text={warning} />}
                </div>
            </div>
        );
    }

    private _toggle(): void {
        this.props.onDestroy && this.props.onDestroy();
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    private async _confirmAction(): Promise<void> {
        const actionResult = await this.props.action();
        if (actionResult) {
            this.setState({
                error: actionResult
            });
        } else {
            this.props.onDestroy && this.props.onDestroy();
            this.setState({
                isModalOpen: false
            });
        }
    }

    private async _denyAction(): Promise<void> {
        this.props.actionDenied && await this.props.actionDenied();
        this.props.onDestroy && this.props.onDestroy();
        this.setState({
            isModalOpen: false
        });
    }
}